import {
  sourcesAtom,
  sourcesTotalCostAtom,
  usesAtom,
  usesTotalCostAtom,
} from "@/financeModels/owasco/sourcesAndUses";
import { Box, SimpleGrid } from "@mantine/core";
import { TotalTable } from "./TotalTable";

export const SourcesAndUses = () => {
  return (
    <SimpleGrid cols={2}>
      <Box>
        <TotalTable
          totalAtom={sourcesTotalCostAtom}
          itemsAtom={sourcesAtom}
          label={"Sources"}
        />
      </Box>
      <Box>
        <TotalTable
          totalAtom={usesTotalCostAtom}
          itemsAtom={usesAtom}
          label={"Uses"}
        />
      </Box>
    </SimpleGrid>
  );
};
